module.exports = __webpack_public_path__ + "img/index.f4e67d3c.jpg";